var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 1920 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.7966L106.667 26.8475C213.333 17.8983 426.667 7.21502e-06 640 11.9136C853.333 24.0509 1066.67 65.4407 1280 68.6288C1493.33 71.5932 1706.67 35.7966 1813.33 17.8983L1920 2.47359e-06V88C1280 88 640 88 0 88V35.7966Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave2.798afce4273c07671d833ac811365282.svg";
export { ForwardRef as ReactComponent };